<template>
  <div class="form-incident-general-detail">

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_01') }}</h4>
    <hr>

    <!--Responsible Email-->
    <b-form-group :label="'A) ' + $t('incident_form_responsible_email')">
      <div>{{ _.get(entity, 'responsible_email') || '-' }}</div>
    </b-form-group>

    <!-- Incident Group -->
    <b-form-group :label="'B) ' + $t('incident_form_group')">
      <div v-if="getIncidentGroupNames.length || _.get(entity, 'other_group')">
        <span v-for="(groupName, index) in getIncidentGroupNames" :key="index">
          {{ groupName }}<span v-if="index < getIncidentGroupNames.length - 1 || _.get(entity, 'other_group')">, <br></span>
        </span>
        <span v-if="_.get(entity, 'other_group')">
          Outro: {{ _.get(entity, 'other_group') }}
        </span>
      </div>
      <div v-else>-</div>
    </b-form-group>

    <!-- Identification Authority Controller -->
    <b-form-group :label="'C) ' + $t('incident_form_authority_identification')">
      <div>{{ _.get(entity, 'legal_entity.name') || '-' }}</div>
    </b-form-group>

    <!-- Operator identification -->
    <b-form-group :label="'D) ' + $t('incident_form_operator_identification')+` (${$t('when_applicable')})`">
      <div>{{ _.get(entity, 'operator_identification') || '-' }}</div>
    </b-form-group>

    <!-- Data Authority Description -->
    <b-form-group :label="'E) ' + $t('incident_form_data_authority_description')">
      <div class="text-break">{{ _.get(entity, 'data_authority_description') || '-' }}</div>
    </b-form-group>

    <!-- Who Reported -->
    <b-form-group :label="'F) ' + $t('incident_form_who_reported')+$t('incident_form_name_tel_email')">
      <div class="text-break">{{ _.get(entity, 'who_reported') || '-' }}</div>
    </b-form-group>

    <!-- Responsible Unit -->
    <b-form-group :label="'G) ' + $t('incident_form_responsible_unit')+$t('incident_form_name_tel_email')">
      <div class="text-break">{{ _.get(entity, 'responsible_unit') || '-' }}</div>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_02') }}</h4>
    <hr>

    <!-- Incident Description -->
    <b-form-group :label="'A) ' + $t('incident_form_description_incident')+` (${$t('incident_form_root_cause')})`">
      <div class="text-break">{{ _.get(entity, 'description') || '-' }}</div>
    </b-form-group>

    <!-- Incident Acid Property -->
    <b-form-group :label="'B) ' + $t('incident_form_affected')">
      <div v-if="getAcidPropertyNames.length">
        <span v-for="(propertyName, index) in getAcidPropertyNames" :key="index">
          {{ propertyName }}<span v-if="index < getAcidPropertyNames.length - 1">, <br></span>
        </span>
      </div>
      <div v-else>-</div>
    </b-form-group>

    <!-- Structure Organization Description -->
    <b-form-group :label="'C) ' + $t('incident_form_structure_organization_description')">
      <div class="text-break">{{ _.get(entity, 'structure_organization_description') || '-' }}</div>
    </b-form-group>

    <!-- How Identified -->
    <b-form-group :label="'D) ' + $t('incident_form_how_identified')">
      <div class="text-break">{{ _.get(entity, 'how_identified') || '-' }}</div>
    </b-form-group>

    <!-- Holders Report -->
    <b-form-group :label="'E) ' + $t('incident_form_holders_report') + ' ' + $t('incident_form_case_yes_contact')">
      <div>{{ _.get(entity, 'holders_report_incident') || '-' }}</div>
    </b-form-group>

    <!-- ANPD Report Incident -->
    <b-form-group :label="'F) ' + $t('incident_form_anpd_report_incident')">
      <div class="text-break">{{ _.get(entity, 'anpd_report_incident') || '-' }}</div>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_03') }}</h4>
    <hr>

    <!-- Incident Leaked -->
    <b-form-group :label="'A) ' + $t('incident_form_leaked_content')">
      <div v-if="getLeakedContentNames.length">
        <span v-for="(contentName, index) in getLeakedContentNames" :key="index">
          {{ contentName }}<span v-if="index < getLeakedContentNames.length - 1">, <br></span>
        </span>
      </div>
      <div v-else>-</div>
    </b-form-group>

    <!-- Category Personal Data -->
    <b-form-group :label="'B) ' + $t('category_personal_data')">
      <div class="text-break">{{ _.get(entity, 'category_personal_data') || '-' }}</div>
    </b-form-group>

    <!-- Data Old or New -->
    <b-form-group :label="'C) ' + $t('incident_form_data_old_or_new')">
      <div class="text-break">{{ _.get(entity, 'data_old_or_new') || '-' }}</div>
    </b-form-group>

    <!-- number_affected_holders -->
    <b-form-group :label="'D) ' + $t('number_affected_holders')">
      <div>{{ _.get(entity, 'number_affected_holders') || '-' }}</div>
    </b-form-group>

    <!-- Total Affected Holders -->
    <b-form-group :label="'E) ' + $t('incident_form_total_affected_holders')+` (${$t('incident_form_total_affected_holders_01')})`">
      <div>{{ _.get(entity, 'total_affected_holders') || '-' }}</div>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_04') }}</h4>
    <hr>

    <!-- incident Date -->
    <b-form-group :label="'A) ' + $t('incident_form_date_incident')">
      <div>{{ _.get(entity, 'incident_date_fmt') || '-' }}</div>
    </b-form-group>

    <!-- incident_form_date_authority -->
    <b-form-group :label="'B) ' + $t('incident_form_date_authority')">
      <div>{{ _.get(entity, 'date_authority_fmt') || '-' }}</div>
    </b-form-group>

    <!-- Reasons Delay -->
    <b-form-group :label="'C) ' + $t('incident_form_reasons_delay')">
      <div class="text-break">{{ _.get(entity, 'reasons_delay') || '-' }}</div>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_05') }}</h4>
    <hr>

    <!-- Data Protection Measures -->
    <b-form-group :label="'A) ' + $t('incident_form_data_protection_measures')+` (${$t('incident_form_data_protection_measures_01')})`">
      <div class="text-break">{{ _.get(entity, 'data_protection_measures') || '-' }}</div>
    </b-form-group>

    <!-- incident_form_actions_reverse_incident -->
    <b-form-group :label="'B) ' + $t('incident_form_actions_reverse_incident')">
      <div class="text-break">{{ _.get(entity, 'actions_reverse_incident') || '-' }}</div>
    </b-form-group>

    <!-- Other Description -->
    <b-form-group :label="'C) ' + $t('incident_form_other_description')+` (${$t('incident_form_other_description_01')})`">
      <div class="text-break">{{ _.get(entity, 'other_description') || '-' }}</div>
    </b-form-group>

    <h4 class="mb-1 mt-1">{{ $t('incident_form.title_06') }}</h4>
    <hr>

    <!-- Related Risks -->
    <b-form-group :label="'A) ' + $t('incident_form_related_risks')">
      <div class="text-break">{{ _.get(entity, 'related_risks') || '-' }}</div>
    </b-form-group>

    <!-- comunication content -->
    <b-form-group :label="'B) ' + $t('incident_form_comunication_content')">
      <div class="text-break">{{ _.get(entity, 'comunication_content') || '-' }}</div>
    </b-form-group>

    <!-- Communication Content attachments -->
    <b-form-group :label="'C) ' + $t('incident_form_communication_content_attachments')" v-if="getCommunicationContentAttachments.length">
      <b-list-group>
        <b-list-group-item
          v-for="(file, idx) in getCommunicationContentAttachments"
          :key="idx"
          class="d-flex justify-content-between align-items-center"
        >
          <div>
            <i class="feather icon-file-text text-primary mr-2"></i>
            <a v-if="getDownloadUrl(file)"
               :href="getDownloadUrl(file)"
               target="_blank"
               class="mr-2 download-link text-primary"
               title="Baixar arquivo">
              <i class="feather icon-download"></i>
            </a>
            <strong>{{ getFileName(file) }}</strong>
            <small class="ml-2 text-muted" v-if="getFileSize(file)">
              ({{ formatFileSize(getFileSize(file)) }})
            </small>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-form-group>

    <!-- ANPD Report Incident -->
    <b-form-group :label="'D) ' + $t('incident_form_anpd_communicated')">
  <div>
        <span v-if="_.get(entity, 'anpd_communicated') !== null && _.get(entity, 'anpd_communicated') !== undefined">
          {{ _.get(entity, 'anpd_communicated') ? 'Sim' : 'Não' }}
        </span>
        <span v-else>-</span>
      </div>
    </b-form-group>

    <!-- Reasons Lack Communication -->
    <b-form-group :label="'E) ' + $t('incident_form_reasons_lack_communication')">
      <div class="text-break">{{ _.get(entity, 'reasons_lack_communication') || '-' }}</div>
    </b-form-group>

     <!-- incident_form_attachments -->
     <b-form-group :label="$t('incident_form_attachments')" v-if="getGeneralAttachments.length">
      <b-list-group>
        <b-list-group-item
          v-for="(file, idx) in getGeneralAttachments"
          :key="idx"
          class="d-flex justify-content-between align-items-center"
        >
          <div>
            <i class="feather icon-file-text text-primary mr-2"></i>
            <a v-if="getDownloadUrl(file)"
               :href="getDownloadUrl(file)"
               target="_blank"
               class="mr-2 download-link text-primary"
               title="Baixar arquivo">
              <i class="feather icon-download"></i>
            </a>
            <strong>{{ getFileName(file) }}</strong>
            <small class="ml-2 text-muted" v-if="getFileSize(file)">
              ({{ formatFileSize(getFileSize(file)) }})
            </small>
          </div>
        </b-list-group-item>
      </b-list-group>
    </b-form-group>

  </div>
</template>

<script>

import {
  BFormGroup,
  BListGroup,
  BListGroupItem,
  VBTooltip
} from 'bootstrap-vue'

import RequestFormIncidentService from '@/services/api/incident/RequestFormIncidentService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BFormGroup,
    BListGroup,
    BListGroupItem,
  },
  props: {
    entity: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      incidentLeakedContentList: [],
      incidentGroupList: [],
      incidentAcidPropertyList: [],
      services: {
        requestFormIncidentService: null,
      }
    }
  },
  computed: {
    getLeakedContentNames() {
      const incidentLeakedContents = _.get(this.entity, 'incident_leaked_contents', [])
      return incidentLeakedContents.map(content => content.name)
    },

    getIncidentGroupNames() {
      const incidentGroups = _.get(this.entity, 'incident_groups', [])
      return incidentGroups.map(group => group.name)
    },

    getAcidPropertyNames() {
      const acidProperties = _.get(this.entity, 'acid_properties', [])
      return acidProperties.map(property => property.name)
    },

    getCommunicationContentAttachments() {
      const communicationAttachments = _.get(this.entity, 'communication_content_attachments', [])
      return communicationAttachments
    },

    getGeneralAttachments() {
      const generalAttachments = _.get(this.entity, 'general_attachments', [])
      return generalAttachments
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return null

      // Se já está no formato DD/MM/YYYY, retorna como está
      if (dateString.includes('/')) {
        return dateString
      }

      // Se está no formato YYYY-MM-DD, converte para DD/MM/YYYY
      if (dateString.includes('-')) {
        const [year, month, day] = dateString.split('-')
        return `${day}/${month}/${year}`
      }

      // Tenta usar moment se disponível
      if (this.$moment) {
        return this.$moment(dateString).format('DD/MM/YYYY')
      }

      return dateString
    },

    async loadLookupData() {
      try {
        const promises = []



        await Promise.all(promises)
      } catch (error) {
        console.error('Erro ao carregar dados de lookup:', error)
      }
    },

    // Método para obter nome do arquivo
    getFileName(file) {
      if (!file) return '';

      // Se é um arquivo que foi enviado (tem name)
      if (file.name) {
        return file.name;
      }

      // Se é um arquivo que foi carregado do servidor (tem file_name)
      if (file.file_name) {
        return file.file_name;
      }

      // Se é um arquivo que tem metadata com original_name
      if (file.metadata && file.metadata.original_name) {
        return file.metadata.original_name;
      }

      return 'Arquivo anexado';
    },

    // Método para obter tamanho do arquivo
    getFileSize(file) {
      if (!file) return null;

      // Se é um arquivo que foi enviado (tem size)
      if (file.size) {
        return file.size;
      }

      // Se é um arquivo que tem metadata com size
      if (file.metadata && file.metadata.size) {
        return file.metadata.size;
      }

      return null;
    },

    // Método para obter URL de download
    getDownloadUrl(file) {
      if (!file) return null;

      // Se é um arquivo que foi enviado (tem url_tmp)
      if (file.url_tmp) {
        return file.url_tmp;
      }

      // Se é um arquivo que foi carregado do servidor (tem metadata)
      if (file.metadata && file.metadata.url_tmp) {
        return file.metadata.url_tmp;
      }

      // Verificar outras possíveis propriedades de URL
      if (file.url_temp) {
        return file.url_temp;
      }

      if (file.url) {
        return file.url;
      }

      if (file.download_url) {
        return file.download_url;
      }

      return null;
    },

    // Método para formatar tamanho do arquivo
    formatFileSize(size) {
      if (!size) return '';
      if (size < 1024) return size + ' B';
      if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
      return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }
  },
  mounted() {
    console.log('FormIncidentGeneralDetail mounted com entity:', this.entity)
  },
  beforeMount() {
    // Inicializa o service
    this.services.requestFormIncidentService = RequestFormIncidentService.build(this.$vs)

    // Carrega os dados de lookup
    this.loadLookupData()
  }
}
</script>

<style lang="scss" scoped>
.text-break {
  word-break: break-word;
  white-space: pre-wrap;
}

// Estilizar especificamente este componente de detalhe
.form-incident-general-detail {
  ::v-deep .form-group {
    label {
      font-weight: 700 !important;
      color: #495057 !important;
      font-size: 0.9rem !important;
      text-transform: none !important;
      margin-bottom: 0.5rem !important;
    }

    > div {
      font-weight: 400 !important;
      font-size: 0.95rem !important;
      background-color: #f8f9fa !important;
      padding: 0.5rem 0.75rem !important;
      border: 1px solid #e9ecef !important;
      border-radius: 0.25rem !important;
      min-height: 2.25rem !important;
      display: flex !important;
      align-items: center !important;
    }
  }
}
</style>
